import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import YouTube from 'react-youtube'

const YouTubeDialog = ({ videoId, autoplay = 1, onClose }) => (
  <ConfirmationDialog
    hasConfirmButton={false}
    maxWidth={1200}
    contentPadding="0"
    onClose={onClose}
  >
    <div style={{ width: 1000, height: 568, background: 'black' }}>
      <YouTube
        videoId={videoId}
        opts={{
          height: '562',
          width: '1000',
          playerVars: {
            autoplay,
            showinfo: 0,
            rel: 0,
            fs: 0
          }
        }}
      />
    </div>
  </ConfirmationDialog>
)

export default YouTubeDialog
